import React, { FC, Fragment, useState } from 'react';
import { List, Typography } from '@mui/material';
import { useMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Desktop, Mobile, MobileSubmenu, SidebarItem, StickySidebar } from 'components';
import { OrganicInsightsFilter } from 'types/app';
import * as paths from 'paths';
import * as Links from 'Links';

const InsightsNav: FC = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const isDefaultInsights = !!useMatch(paths.insights);
  const isInsightsCompanies = !!useMatch(paths.insightsCompanies);
  const isInsightsPeople = !!useMatch(paths.insightsPeople);

  const nav: OrganicInsightsFilter[] = [
    {
      component: Links.Insights,
      isSelected: isDefaultInsights,
      textNode: t('insights:abm_data'),
    },
    {
      component: Links.InsightsCompanies,
      isSelected: isInsightsCompanies,
      textNode: t('insights:companies'),
    },
    {
      component: Links.InsightsPeople,
      isSelected: isInsightsPeople,
      textNode: t('insights:people'),
    },
  ];

  function getMobileTitle() {
    const selectedFilter = nav.find(item => item.isSelected);
    return selectedFilter ? selectedFilter.textNode : '';
  }

  function renderLink(item: OrganicInsightsFilter) {
    const { component, isSelected, textNode } = item;

    return (
      <SidebarItem key={textNode} link={component} isSelected={isSelected} textNode={textNode} />
    );
  }

  function renderDesktop() {
    return (
      <StickySidebar>
        <List component="nav">{nav.map(renderLink)}</List>
      </StickySidebar>
    );
  }

  function renderMobile() {
    return (
      <MobileSubmenu
        expanded={expanded}
        onToggle={isExpanded => setExpanded(isExpanded)}
        selected={<Typography variant="subtitle2">{getMobileTitle()}</Typography>}
      >
        <List component="nav">{nav.map(renderLink)}</List>
      </MobileSubmenu>
    );
  }

  return (
    <Fragment>
      <Desktop>{renderDesktop()}</Desktop>
      <Mobile>{renderMobile()}</Mobile>
    </Fragment>
  );
};

export default InsightsNav;
